import ReactDOM from 'react-dom'
import React from 'react'
import history from 'history'
import radium from 'motion-radium'

// exports
root.exports = root.exports || {}
root.exports.history = history
root.exports.React = React
root.exports.ReactDOM = ReactDOM
root.exports.radium = radium


/** WEBPACK FOOTER **
 ** ./client/shim/exports.js
 **/